<template>
  <div @click="handleWorksheet">
    <Card class="card-box module-card">
      <div class="row">
        <div class="col-7 p-3">
          <img :src="moduleData.trainingImg" v-if="moduleData.trainingImg" class="course-img" />
          <img v-else src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Fb0JfnooRfkiWm-ZNiYcNVs0_pnHZCfdFqaDuaq2swumeP49LZdT4I0fovUIq7CbM0k&usqp=CAU" class="course-img"/>
        </div>
        <div class="col-5 p-0">
          <div class="chart-area p-0">
            <ApexChart
              :options="chartOptions"
              :series="getPercentage(moduleData.totalNoOfTasks, moduleData.completedTasks)"
            />
          </div>
        </div>
      </div>
      <p class="worksheet-title" v-tooltip="moduleData.name">{{ moduleData.name }}</p>
      <p class="reporter-label">
        Trainer: <span class="reporter-title">{{ moduleData.trainer.name }}</span>
      </p>

      <!-- <br /> -->
      <div class="d-block mb-2 mt-2">
        <Badge
          :label="`Start Date: ` + formatDate(moduleData.startedDate)"
          class="badge-rounded badge-rounded-grey-outline"
        />
        <br />
        <Badge
          :label="`Due Date: ` + formatDate(moduleData.endDate)"
          class="badge-rounded badge-rounded-grey-outline"
        />
        <br />
        <Badge
          :label="
            `Completed Date: ` + (moduleData.completedDate ? formatDate(moduleData.completedDate) : 'Not Completed')
          "
          class="badge-rounded badge-rounded-grey-outline"
        />
      </div>
    </Card>
  </div>
</template>

<script>
import Card from "./CardComponent.vue";
import Badge from "./BadgeComponent.vue";

export default {
  name: "ReporteeWorkSheetCardComponent",
  props: {
    moduleData: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 10,
          width: 10,
          type: "radialBar",
          toolbar: {
            show: true,
          },
        },
        plotOptions: {
          radialBar: {
            startAngle: 0,
            endAngle: 360,
            hollow: {
              margin: 0,
              size: "70%",
              background: "#ffffff",
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: "front",
            },
            track: {
              background: "#f3f3f3",
              strokeWidth: "80%",
              margin: 0,
            },

            dataLabels: {
              show: true,
              name: {
                offsetY: -5,
                show: true,
                color: "#888",
                fontSize: "10px",
              },
              value: {
                formatter: function (val) {
                  return val + "%";
                },
                offsetY: 3,
                color: "#000",
                fontSize: "12px",
                show: true,
              },
            },
          },
        },
        fill: {
          type: ["solid"],
          colors: ["#1da8d5"],
        },
        stroke: {
          lineCap: "round",
        },
        labels: ["Progress"],
        fontSize: "10px",
      },
    };
  },
  components: {
    Card,
    Badge,
  },
  methods: {
    getPercentage(totalTask, completedTask) {
      return [
        isNaN(Number(Math.round((completedTask / totalTask) * 100)))
          ? 0
          : Number(Math.round((completedTask / totalTask) * 100)),
      ];
    },
    handleWorksheet() {
      this.$emit("setActiveTraining", this.moduleData);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.card-box {
  padding: 0px 10px 10px 10px;
  border-radius: $field-border-radius;
}
.card-box:hover {
  cursor: pointer;
}

.reporter-label {
  font-size: $font-size-sm;
  color: $badger-orange;
  font-weight: $font-weight-bold;
  margin: 0px;
}

.reporter-title {
  font-size: $font-size-sm;
  color: $light-500;
  font-weight: $font-weight-bold;
  margin: 0px;
}

.chart-area {
  min-width: 150px;
  height: 120px;
}
.course-img {
  border-radius: $field-border-radius;
  background-color: $light-300;
  width: 100%;
  max-height:100px;
  min-height: 100px;
}
.worksheet-title{
   text-overflow: ellipsis;
  display: block;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
}
</style>
